module.exports = __webpack_public_path__ + "csoda.png?5878ad4c64bf207837b60350297ce69c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/csoda.png
// module id = 5
// module chunks = 0